<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>

export default {
    name: 'App',
    components: {
    }
}
</script>

<style>
#app * {
    box-sizing: border-box;
}
html, body {
    margin: 0;
}
p, h4, h2, ul, li  {
    margin: 0;
}
</style>
